import moment from "moment";

export const columns = [
    {
      title: '手机号',
      dataIndex: 'mobile',
      key: 'mobile',
        width: '10%'
    },
    {
      title: '用户ID',
      dataIndex: 'userId',
      key: 'userId',
        width: '10%'
    },
    {
      title: '姓名',
      dataIndex: 'userName',
      key: 'userName',
        width: '10%'
    },
    {
      title: '黑名单时间',
      dataIndex: 'blackDate',
      key: 'blackDate',
                width: '10%'
    },
    {
      title: '原因',
      dataIndex: 'content',
      key: 'content',
        width: '10%',
        scopedSlots: { customRender: "content" },
    },
    {
        title: '状态',
        dataIndex: 'statusName',
        key: 'statusName',
        width: '10%'
    },
    {
      title: '创建人',
      dataIndex: 'createUserName',
      key: 'createUserName',
        width: '10%'
    },
    {
      title: '创建时间',
      dataIndex: 'gmtCreate',
      key: 'gmtCreate',
        width: '10%',
        customRender: (text) =>  {
           if(text) {
               return moment(text).format('YYYY-MM-DD HH:mm:ss')
           } else {
               return '-'
           }
        }
    },
    {
      title: '操作人',
      dataIndex: 'updateUserName',
      key: 'updateUserName',
        width: '10%'
    },
    {
      title: '操作时间',
      dataIndex: 'gmtModified',
      key: 'gmtModified',
        width: '10%',
        customRender: (text) =>  {
            if(text) {
                return moment(text).format('YYYY-MM-DD HH:mm:ss')
            } else {
                return '-'
            }
        },
    },
    {
      title: '操作',
      key: 'action',
        width: '10%',
      scopedSlots: { customRender: 'action' },
    },
]